import { observer } from "mobx-react";
import React from "react";
import Loader from "react-loader-spinner";
import { PoolData } from "types";
import Ram from "../../Ram";
import { loaderColor } from "../../../helpers/constants";
import "./GlobalSection.scss";
import VaultStore from "stores/VaultStore";

type Props = {
  pool: PoolData;
};

function GlobalSection({ pool }: Props) {
  const { chainData, totalStaked, stakingTokenName } = pool;
  const { globalAPY, RAMPerBlock } = VaultStore;

  if (!chainData) return <Loader color={loaderColor} />;

  var element = document.getElementById("section-ram-global");
  let width = 0;
  if (element) {
    width = element.offsetWidth || 0;
  }

  return (
    <div className="section-global">
      <div className="section-title section-title-global">global statistics</div>
      <div id="section-ram-global" className="section-ram">
        <Ram transformValue={!isNaN(globalAPY) ? Math.min(80, globalAPY) : 0} parentWidth={width} />
        <div className="apy">APY {!isNaN(globalAPY) ? globalAPY.toFixed(0) : 0}%</div>
      </div>
      <div className="section-item section-global-assets top-level-item">
        <span className="global-assets-text" style={{ paddingBottom: "1px" }}>
          total assets:
        </span>
        <span className="section-item-value">{totalStaked.toFixed(8)}</span>
        <span className="global-assets-text">{stakingTokenName}</span>
      </div>
      <div className="section-item section-global-assets top-level-item">
        <span className="global-assets-text" style={{ paddingBottom: "1px" }}>
          average rewards per block:
        </span>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <span className="section-item-value">{RAMPerBlock.toFixed(5)}</span>
          <span className="global-assets-text">RAM</span>
        </div>
      </div>
    </div>
  );
}

export default observer(GlobalSection);
